<template>
    <section>
        <modal-component
            :id="`insurance-edit`"
            :visible="contract.hasOwnProperty('id')"
            :title="`Update Insurance Data`"
            :size="`sm`"
            @close="resetModal()"
        >
            <div class="p-3">
                <form>
                    <div class="form-group row" v-for="f in fields">
                        <label :for="f.prop" class="col-7 small">{{ f.title }}:</label>
                        <input
                            type="text"
                            class="form-control form-control-sm col-3 offset-1"
                            :id="f.prop"
                            :name="f.prop"
                            v-model="insurance_eligibility_data[f.prop]"
                            :class="errors[f.prop] ? 'border-danger' : ''"
                        />
                    </div>

                    <div class="d-flex justify-content-end mt-4 my-2">
                        <button
                            class="btn btn-sm btn-primary text-uppercase font-weight-bold text-white"
                            name="save-contract"
                            id="save-contract"
                            @click.prevent="savePatientContract()"
                        >
                            Save
                        </button>
                    </div>
                </form>
                <errors :errors="errors"></errors>
            </div>
        </modal-component>
    </section>
</template>

<script>
import { helpers } from "../../plugins/helpers";
import { errors } from "../../plugins/errors";
import ModalComponent from "../ui/ModalComponent";

export default {
    name: "PatientInsuranceEdit",
    props: ["funding", "contract"],
    mixins: [errors],
    components: { ModalComponent },
    data() {
        return {
            insurance_eligibility_data: {
                coinsurance_percentage: "",
                copay_value: "",
                deductible_amount: "",
                deductible_amount_met: "",
                max_out_of_pocket_amount: "",
                max_out_of_pocket_amount_met: "",
            },
            fields: [
                { prop: "coinsurance_percentage", title: "Co-insurance %" },
                { prop: "copay_value", title: "Copay" },
                { prop: "deductible_amount", title: "Deductible amount" },
                { prop: "deductible_amount_met", title: "Deductible met" },
                { prop: "max_out_of_pocket_amount", title: "Max out of pocket" },
                { prop: "max_out_of_pocket_amount_met", title: "Max out of pocket met" },
            ],
        };
    },
    watch: {
        contract() {
            this.insurance_eligibility_data = {
                coinsurance_percentage: this.contract.coinsurance_percentage,
                copay_value: this.contract.copay_value,
                deductible_amount: this.contract.deductible_amount,
                deductible_amount_met: this.contract.deductible_amount_met,
                max_out_of_pocket_amount: this.contract.max_out_of_pocket_amount,
                max_out_of_pocket_amount_met: this.contract.max_out_of_pocket_amount_met,
            };
            this.setErrors();
        },
    },

    methods: {
        preparePayload() {
            return {
                ...this.insurance_eligibility_data,
                eligibility_updated_at: this.moment().format("YYYY-MM-DD HH:mm:ss"),
            };
        },

        savePatientContract() {
            this.setErrors();
            helpers.toggleSpinner("save-new-contract");
            const payload = this.preparePayload();

            axios
                .patch(
                    `/api/patients/${this.funding.patient.id}/fundings/${
                        this.funding.id
                    }/contracts/${this.contract.id}`,
                    payload
                )
                .then(r => {
                    this.$emit("refresh-fundings");
                    this.resetModal();
                    this.$emit("close");
                    helpers.toggleSpinner("save-new-contract");
                })
                .catch(e => {
                    this.setErrors(_.get(e, "response.data.errors", {}));
                    this.errors = e.response.data.errors;
                    console.error(e);
                    helpers.toggleSpinner("save-new-contract");
                });
        },

        resetModal() {
            this.insurance_eligibility_data = {
                coinsurance_percentage: "",
                copay_value: "",
                deductible_amount: "",
                deductible_amount_met: "",
                max_out_of_pocket_amount: "",
                max_out_of_pocket_amount_met: "",
            };
            this.$emit("close");
        },
    },
};
</script>

<style scoped lang="scss">
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>
